import React from 'react';
import { connect } from 'react-redux';
import { Layout, Search, Card } from 'components';
import * as rdd from 'react-device-detect';
import { axius, func, links } from 'helpers';
import Link from 'next/link';
import Custom404 from 'pages/404';

const Award = (props) => {

    const { award, org, } = props;

    const [q, setQ] = React.useState('');
    const [isMobile, setIsMobile] = React.useState(false);

    React.useEffect(() => {
        setIsMobile(rdd.isMobile);
    }, []);

    const categories = q ? props.categories.filter(d => d.name.toLowerCase().includes(q.toLowerCase())) : props.categories;

    return (
        <React.Fragment>
            {org.uuid && award.status === 1 ? (
                <Layout
                    Head={{
                        url: links.award(award).as,
                        title: award.name,
                        image: award.logo ? award.logo_link : org.logo_link,
                        description: `${award.name}. ${org.description}`
                    }}
                >
                    <main className="bg-greys pb-30">
                        <div className={`entry-header entry-header-style-2 ${isMobile ? 'pb-40 pt-40' : 'pb-80 pt-80'} mb-50 text-white`}
                            style={{ backgroundImage: `url('assets/img/bg-award.jpg?v=${func.app.version}')`, backgroundAttachment: 'fixed' }}
                        >
                            <div className="container container-sm entry-header-content">
                                <div className="entry-meta align-items-center meta-2 font-small color-white">
                                    <div className="mb-5 text-white">
                                        <div className="author-avatar">
                                            <div className="img-bg img-circle"
                                                style={{ backgroundImage: `url('${award.logo ? award.logo_link : org.logo_link}')`, height: 100, width: 100, border: '2px solid #fff', margin: '0 auto' }}
                                            >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h1 className="entry-title font-weight-900 text-shadow">{award.name}</h1>
                                <p className="mb-50s">
                                    <Link as={links.organisation(org).as} href={links.organisation(org).href}>
                                        <a className="text-white">{org.name}</a>
                                    </Link>
                                </p>
                                <div className="text-center mt-30">
                                    {award.preferences.show_results && [45].includes(award.id) && (
                                        // <Link as={links.result(award, true).as} href={links.result(award, true).href}>
                                        <a href={links.result(award, true).as} className="btn button btn-primary btn-round text-white mr-3s">
                                            &nbsp; &nbsp; <small>{func.intl('Button.ViewResults', 'View results')}</small> &nbsp; &nbsp;
                                        </a>
                                        // </Link>
                                    )}
                                    {func.checkDates(award.date_nomination.start, award.date_nomination.end) && (
                                        <Link as={links.nominate(award).as} href={links.nominate(award).href}>
                                            <a className="btn button btn-primary btn-round text-white">
                                                &nbsp; &nbsp; <small>{func.intl('Button.Nominate', 'Nominate')}</small> &nbsp; &nbsp;
                                            </a>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="container">
                            <Search kay={func.intl('Label.Category', 'category').toLowerCase()} onSearch={setQ} />

                            <div className="loop-grid mb-30">
                                {categories.length === 0 && (
                                    <div className="text-center">
                                        <span className="font-weight-900">{org.name}</span> {func.intl('Text.Empty', 'has not yet published any {page} in', { page: 'categories' })} <span className="font-weight-900">{award.name}</span>.
                                    </div>
                                )}
                                {categories.length > 0 && (
                                    <div className="row">
                                        {(categories || []).map(row => (
                                            <Card key={row.uuid} kay="category" row={row} org={org} />
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                    </main>
                </Layout>
            ) : (
                <Custom404 />
            )}
        </React.Fragment>
    )
}


export async function getServerSideProps(ctx) {
    const { award } = ctx.query;
    const id = parseInt((award || '').split('.')[1]);
    const resAwd = await axius.get(`awards/${id}`, {});
    const resCtg = resAwd.status === 200 ? await axius.get(`categories`, { award: resAwd.data.uuid, status: 1, orderby: 'name_asc' }) : {};
    return {
        props: {
            org: resAwd.status === 200 ? resAwd.data.organisation : {},
            award: resAwd.data || {},
            categories: resCtg.data || {},
        },
    }
};

const mapStateToProps = (state) => ({
    _data: state.data,
});

export default connect(mapStateToProps, {})(Award);